var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelMobileSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:0.9359999999999999;}")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.32,
    y: 1.5,
    width: 13.36,
    height: 21,
    rx: 1.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.05,
    y1: 18.68,
    x2: 12.95,
    y2: 18.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.91,2.45H10.09a.94.94,0,0,1-.95-1h5.72A.94.94,0,0,1,13.91,2.45Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.14,
    y1: 6.27,
    x2: 9.14,
    y2: 13.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.86,
    y1: 6.27,
    x2: 14.86,
    y2: 13.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.14,
    y1: 10.09,
    x2: 14.86,
    y2: 10.09
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelMobileSvgrepoCom);
export default __webpack_public_path__ + "static/media/hotel-mobile-svgrepo-com.f4b7f7737978e0b5f7d91111617e7ec5.svg";
export { ForwardRef as ReactComponent };